export const getErrorMessage = (error) => {
  switch (error) {
    default:
      return 'COMMON.DEFAULT_ERROR';
  }
};
